import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询频率
export function queryfrequency (data) {
  return request({
    url: '/queryfrequency',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询项目
export function queryproject (data) {
  return request({
    url: '/queryproject',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询老人 （服务对象）
export function queryoldperson (data) {
  return request({
    url: '/queryoldperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 分页查询老人（服务对象）
export function queryoldpersonpage (data) {
  return request({
    url: `/queryoldpersonpage`,
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      orgid: data.orgid
    }
  })
}
// 按照多个 oid (组织)查找老人，分页接口
export function queryoldpersonbyoids (data) {
  return request({
    url: `/queryoldpersonbyoids`,
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      oids: data.oids
    }
  })
}
// 按照姓名搜索查询老人searcholdperson
export function searcholdperson (data) {
  return request({
    url: '/searcholdperson',
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      lessname: data.lessname
    }
  })
}
// 新增长者
export function addoldperson (data) {
  return request({
    url: '/addoldperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改长者
export function updateoldperson (data) {
  return request({
    url: '/updateoldperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除长者
export function deleteoldperson (data) {
  return request({
    url: '/deleteoldperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询家人
export function queryfamilyperson (data) {
  return request({
    url: '/queryfamilyperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新增家人
export function addfamilyperson (data) {
  return request({
    url: '/addfamilyperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改家人
export function updatefamilyperson (data) {
  return request({
    url: '/updatefamilyperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除家人
export function deletefamilyperson (data) {
  return request({
    url: '/deletefamilyperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 生成外勤客服订单
export function addlaweralarminfo (data) {
  return request({
    url: '/addlaweralarminfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 呼叫结束
export function sipphonecallend (data) {
  return request({
    url: '/sipphonecallend',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询服务对象下的家庭设备详情
export function querybinddevicebyhome (data) {
  return request({
    url: '/querybinddevicebyhome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 添加个人其它号码
export function addpersonotherphone (data) {
  return request({
    url: '/addpersonotherphone',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询个人其它号码
export function querypersonotherphone (data) {
  return request({
    url: '/querypersonotherphone',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除个人其它号码
export function deletepersonotherphone (data) {
  return request({
    url: '/deletepersonotherphone',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 提交审核
export function addcheckinfo (data) {
  return request({
    url: '/addcheckinfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/serviceObject.js